import React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import { useHeaderFooter } from '../../hooks';
import { CoursesInProgress } from '../../components';

import './index.scss';
import messages from './messages';

import promoImg from '../../img/courseCatalogue/MODULES-LIST-LWC.jpg';

interface CourseCatalogueProps {
  children?: React.ReactNode;
}

const CourseCatalogue: React.FC<CourseCatalogueProps> = ({ children }) => {
  const intl = useIntl();
  const { headerContent, footerContent } = useHeaderFooter(children);
  const headingLead = (chunks: React.ReactNode) => (
    <span className="recklessneue-regular-normal-white-100-1px-custom">{chunks}</span>
  );
  const headingTail = (chunks: React.ReactNode) => <span className="instrumentserif-normal-white-100-1px">{chunks}</span>;

  return (
    <div className="container-center-horizontal">
      <div className="about screen courses_ab">
        <div className="homepage">
          {headerContent}
          <div className="overlap-group6">
            <div className="hero-image">
              <div className="overlap-group-1">
                <div className="grad" />
                <img
                  className="overlap-group-item"
                  src={promoImg}
                  alt=""
                />
                <h1 className="about-us recklessneue-regular-normal-white-100-1px-custom">
                  {intl.formatMessage(messages.heading, {
                    lead: headingLead,
                    br: <br />,
                    tail: headingTail,
                  })}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="course-overview-text">
          <div className="overlap-group5">
            <p className="lorem-ipsum-dolor-si-1 neuehaasgroteskdisplaypro-45-light-congress-blue-24px">
              {intl.formatMessage(messages.catalogueIntro)}
            </p>
          </div>
        </div>
        <div className="courses-grid course-catalogue course-container logged-in">
          <CoursesInProgress showOnProgress={false} title={'  '} showAll />
        </div>
        {footerContent}
      </div>
    </div>
  );
};

export default CourseCatalogue;
